<template>
    <vue-apex-charts
        class="dashboard-graph"
        :height="chartHeight"
        :width="chartWidth"
        :ref="refName"
        :options="options"
        :series="chartOptions.series"
        :categories="chartOptions.categories"
    ></vue-apex-charts>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    props: {
        chartOptions: {
            type: Object,
            required: false
        },
        refName: {
            type: String,
            required: false
        },
        isCurrency: {
            type: Boolean,
            default: false
        },
        isQuantity: {
            type: Boolean,
            default: false
        },
        colorsData: {
            type: Array,
            required: false
        },
        chartHeight: {
            type: String,
            required: false
        },
        chartWidth: {
            type: String,
            required: false
        },
        labelWidth: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            options: {
                chart: {
                    type: this.chartOptions.chartType,
                    toolbar: {
                        show: false
                    },
                    offsetX: this.chartOptions?.offsetX || 0
                },
                stroke: {
                    curve: 'straight'
                },
                title: {
                    show: false
                },
                legend: {
                    enabled: false
                },
                dataLabels: {
                    enabled: false
                },
                series: this.series,
                colors: this.colorsData,
                fill: {
                    type: 'gradient',
                    gradient: {
                        type: 'horizontal',
                        gradientToColors: ['rgb(107, 182, 69)']
                    }
                },
                yaxis: {
                    title: {
                        text: this.chartOptions.yaxis.title.text,
                        offsetX: 8
                    },
                    labels: {
                        minWidth: this.labelWidth,
                        maxWidth: this.labelWidth,
                        offsetX: this.chartOptions.yaxis?.labels?.offsetX || 0,
                        align: this.chartOptions.yaxis?.labels?.align || 'right'
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                xaxis: {
                    title: {
                        text: this.chartOptions.categoriesTitle
                    },
                    categories: this.chartOptions.categories
                },
                tooltip: {
                    y: {
                        formatter: val => {
                            if (this.isCurrency) {
                                return val + ' zł'
                            } else if (this.isQuantity) {
                                return val + ' szt.'
                            }
                            return val
                        }
                    }
                }
            },
            series: this.chartOptions.series
        }
    },
    components: {
        VueApexCharts
    }
}
</script>
